import { Component, Inject, OnInit, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrganizationSecretariesAffiliationService } from 'app/core/http/services/organization-secretaries-affiliation.service';
import { DialogData } from 'app/core/interfaces/dialog';
import { organizationI } from 'app/core/interfaces/organization';
import { OrganizationService } from 'app/modules/organization/organization.service';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { MaterialDialog } from 'app/modules/shared/components/dialog/dialog.component';
import { OrganizationSecretariesDetailsComponent } from '../details/organization-details.component';

@Component({
  selector: 'page-organization-link',
  templateUrl: './organization-link.component.html',
  styleUrls: ['./organization-link.component.scss'],
})
export class OrganizationSecretariesLinkComponent
  extends BaseComponent
  implements OnInit
{
  public organizations: any[] = [];
  public organization: any = <organizationI>{};
  public search = '';
  public get organizationsFilter(): any[] {
    const organizations = [...this.organizations];
    return organizations.filter(
      (item: any) =>
        this.search == '' ||
        (item.name && item.name.indexOf(this.search) > -1) ||
        (item.address &&
          item.address.city &&
          item.address.city.indexOf(this.search) > -1)
      //&& !item.practitioners?.includes(this.currentUser.user.id as number)
      // && item.active == true
    );
  }

  public locations: any[] = [];
  public affiliations: any[] = [];

  public secretary: any = {};

  public refreshMainComponent = false;

  constructor(
    public dialogRef: MatDialogRef<MaterialDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private organizationService: OrganizationService,
    private affiliationOrganizationService: OrganizationSecretariesAffiliationService,

    private injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.getOrganizations();

    const currentUser = this.currentUser.user;

    this.secretary = {
      name: currentUser.name,
      secretary_id: currentUser.id,
    };

    if (this.data.param) {
      this.affiliations = this.data.param.affiliations;
      this.locations = this.data.param.location;
    }
  }

  public transformObjectToFHIR(data: any) {
    const transformedData = {
      resourceType: 'Affiliation',
      affiliation_id: data.organization_id,
      request: {
        id: data.secretary_id,
        referenceType: 'Secretaries',
        display: this.secretary.name,
      },
      subject: {
        id: data.organization_id,
        referenceType: 'Organization',
        display: data.organization_name,
      },
      status: 'requested',
      requestDateTime: data.requestDateTime,
      updateDateTime: data.updateDateTime,
    };

    return transformedData;
  }

  transformFhirToModel(jsonData: any[]) {
    const transformedFhir = jsonData.map((item) => {
      const {
        affiliation_id,
        request: { id: secretary_id, display: secretary_name },
        subject: { id: organization_id, display: organization_name },
        status,
      } = item;

      return {
        affiliation_id,
        secretary_name,
        secretary_id,
        organization_name,
        organization_id,
        status,
      };
    });

    return transformedFhir;
  }

  getOrganizations() {
    this.organizationService.list().subscribe({
      next: (resOrganization: any) => {
        //adicionar lógica para remover as organizações que possuem status requested ou concluded
        const affiliations = this.affiliations.filter(
          (affiliation) =>
            affiliation.status == 'requested' ||
            affiliation.status == 'accepted'
        );

        const organizationIdInAffiliation = affiliations.map(
          (affiliation) => affiliation.organization_id
        );

        this.organizations = resOrganization.filter(
          (organization: any) =>
            !organizationIdInAffiliation.includes(organization.organization_id)
        );
      },
      error: (err) => {
        console.log('erro', err);
      },
    });
  }

  getCity(organization_id: string) {
    const location = this.locations.find(
      (location) =>
        location.managingOrganization?.reference ===
        `organization/${organization_id}`
    );

    if (!location) return null

    return location?.address[0]?.city || null;
  }

  getAddress(organization_id: string) {
    const location = this.locations.find(
      (location) =>
        location.managingOrganization?.reference ===
        `organization/${organization_id}`
    );
    return location?.address[0] || null;
  }

  openOrganizationDetailForm(organization: any) {
    const data = {
      title: organization.organization_name,
      param: {
        id: organization.organization_id,
        location: this.getAddress(organization.organization_id),
      },
    };

    this.dialog.openComponentDialog(
      OrganizationSecretariesDetailsComponent,
      data
    );
  }

  linkOrganization(organization: any) {
    const organizationAffiliation = {
      organization_id: organization.organization_id,
      organization_name: organization.name,
    };

    const currentDate = new Date().toISOString();

    const affiliation = {
      ...organizationAffiliation,
      ...this.secretary,
      requestDateTime: currentDate,
      updateDateTime: currentDate,
    };

    const afffiliationFHIR = this.transformObjectToFHIR(affiliation);

    this.affiliationOrganizationService.create(afffiliationFHIR).subscribe({
      next: (resAffiliation) => {
        organization.isHidden = true;
        this.refreshMainComponent = true;

        this.openSnackBar(
          'Afiliação à organização solicitada com sucesso',
          'success'
        );
      },
      error: (err) => {
        console.log('ERRO', err);
      },
    });
  }
}
